module.exports = __webpack_public_path__ + "static/media/coopercau.163780d2.jpg";